import Vue from "vue";
import Buefy from "buefy";
import BlogList from "./App.vue"


Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(BlogList)

if(document.getElementById("blogPublicListApp")){
    new Vue({
        render:h=>h(
            BlogList,{
                props:{
                    blogList:document.getElementById("blogPublicListApp")
                        .getAttribute("blogList"),
                    blogSections:document.getElementById("blogPublicListApp")
                        .getAttribute("blogSections")
                }
            }
        )
    }).$mount("#blogPublicListApp")
}